package uz.ferro.erp.feature.task.model

enum class TaskStatus {
    DRAFT,
    ASSIGNED,
    IN_PROGRESS,
    COMPLETED,
    CANCELLED
}